import * as types from '../types'

const state = {
  dialogName: ""
}

const getters = {
}

const actions = {

}

const mutations = {
  [types.SHOWDIALOG](state,playload){
    state.dialogName = playload.dialogName;
  },
  [types.CLOSEDIALOG](state,playload){
    if(playload.className === 'el-dialog__wrapper' || playload.innerText === '取消' || playload.innerText === '确认' || playload.className === 'el-dialog__close el-icon el-icon-close'){
      state.dialogName = ""
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dialog.js